import React, { FC, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { PssRoutePath } from "./configs/_pss.route-path";
import pssRoutes from "./configs/_pss.routes";
import { MainAppsRepo } from "../Apps";
import { LoadingOverlay } from "../components";
import { usePssThemeSwitcher } from "./features/layout/controllers";

const PssAppLayout = React.lazy(() => import("./features/layout/PssAppLayout"));
const PssLogin = React.lazy(
  () => import("./features/authentication/views/PssLogin"),
);

interface AppPssProps {
  changeApp(app: MainAppsRepo): void;
}

const AppPss: FC<AppPssProps> = ({ changeApp }) => {
  const {
    state: { theme },
  } = usePssThemeSwitcher();
  return (
    <div className={theme !== "dark" ? "pss-light" : "pss-dark"}>
      <Suspense fallback={<LoadingOverlay isOpen={true} />}>
        <Routes>
          <Route path={PssRoutePath.Login} element={<PssLogin />} />
          <Route
            path={PssRoutePath.Home}
            element={<PssAppLayout changeApp={changeApp} />}
          >
            {pssRoutes.map((route, idx) => {
              return (
                route.component && (
                  <Route
                    key={idx}
                    path={route.path}
                    element={React.createElement(route.component)}
                  />
                )
              );
            })}
            <Route
              path={PssRoutePath.Home}
              element={<Navigate to={PssRoutePath.Dashboard} />}
            />
            <Route
              path="*"
              element={
                <Navigate to={PssRoutePath.NotFoundError} replace={true} />
              }
            />
          </Route>
          <Route path="*" element={<Navigate to={PssRoutePath.Home} />} />
        </Routes>
      </Suspense>
    </div>
  );
};
export default AppPss;
